import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
  };

  open() {
    this.showDialog();

    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
     */
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}

// --- Terms checkbox for Cart Drawer ---
// --- Terms checkbox for Cart Drawer ---
function bindCartTerms() {
  const drawer = document.querySelector('.cart-drawer__dialog');
  const form = document.getElementById('cart-form');
  if (!drawer || !form) return;

  const checkbox    = drawer.querySelector('#CartTerms');
  const checkoutBtn = drawer.querySelector('[name="checkout"], #checkout');
  const accelWrap   = drawer.querySelector('.additional-checkout-buttons');
  const errorLine   = drawer.querySelector('.terms-error');

  if (!checkbox || !checkoutBtn || !errorLine) return;

  // 1) Disable native validation/popups completely
  checkbox.removeAttribute('required');
  form.setAttribute('novalidate', '');
  checkoutBtn.setAttribute('formnovalidate', '');
  form.addEventListener('invalid', (e) => { e.preventDefault(); }, true);

  // 2) Visual state: show inline "Required" & gate accelerated buttons
  const updateState = () => {
    const blocked = !checkbox.checked;
    errorLine.style.display = blocked ? '' : 'none';
    if (accelWrap) {
      accelWrap.style.pointerEvents = blocked ? 'none' : '';
      accelWrap.style.opacity = blocked ? '0.5' : '';
      accelWrap.setAttribute('aria-disabled', String(blocked));
    }
  };

  // 3) Quietly block submit (NO alerts, NO reportValidity)
  form.addEventListener('submit', (e) => {
    if (!checkbox.checked) {
      e.preventDefault();
      updateState();
      checkbox.focus();
    }
  }, { passive: false });

  checkbox.addEventListener('change', updateState);
  updateState();
}



document.addEventListener('DOMContentLoaded', bindCartTerms);
document.addEventListener('cart:updated', bindCartTerms);
document.addEventListener('cart-drawer:open', bindCartTerms);
